import type { PopOverMenuProps } from './types';
import React from 'react';
import { Styled } from './index.styles';

export const PopOverMenu: React.FC<PopOverMenuProps> = ({
  content,
  hideOnScroll = false,
  offset,
  onOutsideClick,
  position = 'bottom center',
  show,
  trigger,
}) => {
  // Close menu when file drag starts
  React.useEffect(() => {
    const handleFileDragStart = () => {
      if (show && onOutsideClick) {
        onOutsideClick();
      }
    };
    window.addEventListener('file-drag-start', handleFileDragStart);
    return () => {
      window.removeEventListener('file-drag-start', handleFileDragStart);
    };
  }, [show, onOutsideClick]);
  return (
    <Styled.Popup
      {...{ trigger, position, offset, hideOnScroll }}
      open={show}
      on="click"
      content={<Styled.PopupContent>{content}</Styled.PopupContent>}
      onClose={onOutsideClick}
    />
  );
};
